var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c("h3", [_vm._v("Daftar Pasien")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("DataTable", {
        attrs: {
          "table-id": "table-pasien",
          title: "Data Pasien",
          "filter-configs": _vm.filterConfigs,
          "table-options": _vm.tableOptions,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }